import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { modernTheme, darkTheme } from './modernTheme';

const ThemeContext = createContext();

export const useThemeMode = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // O PADRÃO É ESCURO, por decisão do dono: é a identidade do produto, e o
  // claro é a contraparte para quem trabalha sob luz forte. Quem já escolheu
  // continua com a escolha dele — a preferência salva sempre vence.
  const [mode, setMode] = useState(() => {
    const savedMode = localStorage.getItem('themeMode');
    return savedMode || 'dark';
  });

  // Salvar preferência no localStorage quando mudar
  useEffect(() => {
    localStorage.setItem('themeMode', mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  // Fonte unica da verdade visual: modernTheme.js. Antes este arquivo definia
  // uma segunda paleta inteira aqui dentro, e era ela que aparecia na tela —
  // mexer no tema nao surtia efeito nenhum.
  const theme = useMemo(() => (mode === 'dark' ? darkTheme : modernTheme), [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};
